import { Box, Img, INK, Page, Text } from "../primitives";
/** Reference page 2 — «ارتيكا / فن ذكي. لمسة بشرية». Fully fixed. */
export function BrandPage() {
    return (<Page background={INK}>
      <Img src="/proposal-assets/template/brand-photo.jpg" x={-15.1} y={-10.5} w={1174.6} h={829.7}/>
      <Box x={0} y={0} w={1125} h={810} style={{ background: INK, opacity: 0.685 }}/>
      <Text center={583} top={312} size={103} weight={700} color="#ffffff">
        ارتيكا
      </Text>
      <Text center={579} top={469} size={16} weight={300} color="#ffffff">
        فن ذكي. لمسة بشرية
      </Text>
    </Page>);
}
